const Colours = {
  black: "black",
  white: "white",
  gold: "#BA9650",
  grey: "#545454",
};

export default Colours;
